import React from "react";
import styled from "styled-components";
import DropBooking from "./drop-booking/DropBooking";
import BookingAccessControl from "./booking-access-control/BookingAccessControl";
import ReasonContent from "./reasons/ReasonContent";
import DATA_LABEL_TABLE from "../../utils/constants/dataLabelTable";
import { OwcTab, OwcTabs } from "@one/react";
import styles from "./AdminTabs.module.scss";
import { useSelector, connect } from "react-redux";
import { getAllBookingInstrumentsListByUserSite } from "../../utils/helpers/fetching";
import { loadBookingInstruments } from "../booking-instruments/redux/actions";
import { compose, withApollo } from "react-apollo";
import { filterBookingData } from "../../utils/helpers/text";
import BackdropPortal from "../../components/shared/BackdropPortal";

export const AdminTabStyled = styled.div`
  width: 100%;
  padding: 20px 0 20px 0;
  @media only screen and (max-width: 960px) {
    padding: 0 12px;
  }
`;

const AdminTabs = ({
  client,
  loadBookingInstruments,
  setSubscriptionStatus,
  subscriptionStatus,
  setPopupEnableStatus,
  eventID = null,
  urlAction = null,
}) => {
  const [value, setValue] = React.useState("dropBooking");
  const [fetching, setFetching] = React.useState(false);
  const handleChange = (e) => {
    setValue(e.detail);
  };

  const user = useSelector((state) => state.user);
  const storeUser = useSelector((theStore) => theStore.user)

  const getBookingItems = async () => {
    //FIXME: Caution we are only fetching the first 1000
    const allBookingEquipmentList = await getAllBookingInstrumentsListByUserSite({
      client,
      user,
    });
    const filteredBookingEquipmentList = filterBookingData(allBookingEquipmentList, user?.user, storeUser);
    loadBookingInstruments({
      bookingInstruments: filteredBookingEquipmentList.map((instrument) => ({
        ...instrument,
        instrumentAvailability: instrument?.addInfo?.instrumentAvailability?.toLowerCase() ?? null,
      })),
    });
    setFetching(false);
  };

  return (
    <div className={styles.contentTabs}>
      <OwcTabs value={value} onTabChange={handleChange} style={{ backgroundColor: "var(--one-color-cobas-white)" }}>
        <OwcTab
          data-testid="admin-tab-drop-booking"
          label={DATA_LABEL_TABLE.ADMIN_TABS.booking_managment}
          value="dropBooking"
        >
          {DATA_LABEL_TABLE.ADMIN_TABS.booking_managment}
        </OwcTab>
        <OwcTab
          data-testid="admin-tab-widgets"
          label={DATA_LABEL_TABLE.ADMIN_TABS.reason_management}
          value="reasonManagement"
        >
          {DATA_LABEL_TABLE.ADMIN_TABS.reason_management}
        </OwcTab>
        <OwcTab
          data-testid="admin-tab-reason-management"
          label={DATA_LABEL_TABLE.ADMIN_TABS.booking_access_control}
          value="accessControl"
        >
          {DATA_LABEL_TABLE.ADMIN_TABS.booking_access_control}
        </OwcTab>
      </OwcTabs>

      <BackdropPortal show={fetching} />
      <>
        {value === "dropBooking" && (
          <DropBooking
            setSubscriptionStatus={setSubscriptionStatus}
            subscriptionStatus={subscriptionStatus}
            setPopupEnableStatus={setPopupEnableStatus}
            eventID={eventID}
            urlAction={urlAction}
          />
        )}
        {value === "reasonManagement" && <ReasonContent />}
        {value === "accessControl" && (
          <BookingAccessControl getBookingItems={getBookingItems} />
        )}
      </>
    </div>
  );
};

export default compose(
  connect(null, {
    loadBookingInstruments,
  }),
  withApollo
)(AdminTabs);
